@if (!appendToBody) {
  @if (show) {
    <div class="ts-submit-popup-backdrop" aria-hidden="true"></div>
    <ng-container *ngTemplateOutlet="dialogInner"></ng-container>
  }
} @else {
  <div #bodyRoot class="ts-submit-popup-body-root" [style.display]="show ? 'block' : 'none'">
    <div class="ts-submit-popup-backdrop" aria-hidden="true"></div>
    <ng-container *ngTemplateOutlet="dialogInner"></ng-container>
  </div>
}

<ng-template #dialogInner>
  <div
    class="ts-submit-popup"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="'ts-submit-popup-title'"
    [attr.aria-describedby]="'ts-submit-popup-message'"
  >
    <div class="ts-submit-popup__card">
      <div class="ts-submit-popup__hero">
        <div class="ts-submit-popup__hero-media" aria-hidden="true">
          <img class="ts-submit-popup__hero-image" src="assets/images/time_not_filled.png" alt="" loading="lazy" decoding="async" />
        </div>
        <div class="ts-submit-popup__hero-copy">
          <p class="ts-submit-popup__eyebrow">
            <mat-icon>lock</mat-icon>
            <span>Action required</span>
          </p>
          <h2 class="ts-submit-popup__title" id="ts-submit-popup-title">{{ title }}</h2>
          <p class="ts-submit-popup__message" id="ts-submit-popup-message">{{ message }}</p>
        </div>
      </div>

      <div class="ts-submit-popup__content">
        <div class="ts-submit-popup__hours" aria-label="Total hours filled">
          <div class="ts-submit-popup__hours-icon" aria-hidden="true">
            <mat-icon>hourglass_top</mat-icon>
          </div>
          <div class="ts-submit-popup__hours-meta">
            <span class="ts-submit-popup__hours-label">Total hours filled</span>
            @if (hoursLoading) {
              <span class="ts-submit-popup__hours-loader" role="status" aria-live="polite" aria-label="Loading total hours filled">
                <app-spinner [size]="22"></app-spinner>
              </span>
            } @else {
              <span class="ts-submit-popup__hours-value">
                {{ formattedHours() }}
                <span class="ts-submit-popup__hours-unit">hrs</span>
              </span>
            }
          </div>

          <button type="button" class="btn-save ts-submit-popup__cta" (click)="onConfirm()">
            <span>{{ confirmText }}</span>
            <mat-icon class="ts-submit-popup__cta-arrow">arrow_forward</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
